'use strict';

function Failed() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [];
  this.centeredElement = null;

  this.init = function () {};

  this.initAllReady = function () {
    var _this = this;

    this._portalPresenter = document.getElementById('Portal').mogo();
    this.analytics.pushEvent('virtual-page-view');

    if (this.presenter.models.account.verification_level === 4) {
      this.analytics.pushEvent('account-status', { AccountStatus: ['verification-level-4'] });
    }
    if (this.presenter.models.account.kyc_decision === 'profile_not_found') {
      this.analytics.pushEvent('account-status', { AccountStatus: ['profile_not_found'] });
    }

    var logoutButtonEl = document.querySelector('#DeclinedKYCLastAttempt .js--logout');

    if (logoutButtonEl) {
      logoutButtonEl.addEventListener('click', function () {
        return _this._portalPresenter._onLogout();
      });
    }
  };

  this.destroy = function () {};
}